import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Parse from "parse";
import { useGame } from "../header/GameContext";
import ConeBig from "../../img/clear/img_cone-big.png";
import Header from "../header/header";
import "./clear.css";

export default function Clear({ timerMode = "pause" }) {
  const { state } = useLocation();

  const {
    time,
    playerName,
    playerKeyCode, // 🔑 ADD
    startTimer,
    pauseTimer,
  } = useGame();

  /* =========================
     타이머 제어 (기존 유지)
  ========================= */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode, startTimer, pauseTimer]);

  /* =========================
     이름 (기존 유지)
  ========================= */
  const userName = playerName || "익명";

  /* =========================
     날짜 (기존 유지)
  ========================= */
  const today = new Date();
  const dateText = `${today.getFullYear()}-${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  /* =========================
     탈출 시간 (기존 유지)
  ========================= */
  const usedTime = 1800 - time;
  const minutes = Math.floor(usedTime / 60);
  const seconds = usedTime % 60;
  const escapeTime = `${minutes}분 ${seconds < 10 ? "0" : ""}${seconds}초`;

  /* =========================
     🔥 DB 저장 (ADD)
     - keyCode 기준 update
     - 최초 1회만 저장
  ========================= */
  const savedRef = useRef(false);

  useEffect(() => {
    if (!playerKeyCode || savedRef.current) return;

    const saveClearTime = async () => {
      try {
        const GameUser = Parse.Object.extend("yit1");
        const query = new Parse.Query(GameUser);

        query.equalTo("keyCode", playerKeyCode);
        const user = await query.first();

        if (!user) {
          console.error("❌ 해당 keyCode 유저 없음");
          return;
        }

        user.set("clearTime", usedTime);
        user.set("clearDate", dateText); // 선택 사항
        await user.save();

        savedRef.current = true;
        console.log("✅ 클리어 DB 저장 완료");
      } catch (e) {
        console.error("❌ 클리어 DB 저장 실패", e);
      }
    };

    saveClearTime();
  }, [playerKeyCode, usedTime, dateText]);

  /* =========================
     공유 버튼 (기존 유지)
  ========================= */
  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert("URL이 클립보드에 복사되었습니다.");
    } catch (e) {
      alert("복사에 실패했습니다.");
    }
  };

  return (
    <div id="content">
      <Header />

      <div className="box content_box1 ans0001">
        <div className="box_con con_box1 con_pd5 con_box_c">
          <div className="mission_tit clearTit"></div>

          <p className="clearBT mt40">방탈출 성공!</p>

          <div className="clearImgBox mt16">
            <img src={ConeBig} alt="clear" />
          </div>

          <div className="clearInfoBox mt16">
            <p className="clearBTxt">이름 : {userName}</p>
            <p className="clearBTxt">날짜 : {dateText}</p>
            <p className="clearBTxt">탈출 시간 : {escapeTime}</p>
            <p className="clearTxt">방탈출에 성공했음을 인증합니다.</p>
          </div>

          {/* 🔽 기존 버튼 전부 유지 */}
          <div id="box_ft">
            <input
              type="button"
              className="inputBtn02 btnCode"
              value="공유하기"
              onClick={handleShare}
            />

            <input
              type="button"
              className="inputBtn02 btnCode mt16"
              value="미션 해결 소감 쓰기"
              onClick={() =>
                (window.location.href = "https://forms.gle/YPLcYnciPwLu5jKa6")
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
